import React, { useCallback, useState } from 'react';

export const useScrubberPreview = (totalFrames: number) => {
    const containerRef = React.useRef<HTMLDivElement>(null);
    const [hoverData, setHoverData] = useState<{
        frame: number;
        x: number;
        percent: number;
    } | null>(null);

    const handleMouseMove = useCallback(
        (event: React.MouseEvent) => {
            if (!containerRef.current) return;

            const rect = containerRef.current.getBoundingClientRect();
            const x = Math.max(
                0,
                Math.min(event.clientX - rect.left, rect.width),
            );
            const percent = x / rect.width;
            const frame = Math.floor(percent * totalFrames);

            setHoverData({ frame, x, percent });
        },
        [containerRef, totalFrames],
    );

    const clearHover = useCallback(() => setHoverData(null), []);

    return {
        containerRef,
        hoverData,
        handleMouseMove,
        clearHover,
    };
};
